import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { content } = useSite();
  return (
    <footer className="relative bg-navy text-white grain overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-20 flex flex-col md:flex-row md:items-end justify-between gap-12">
        <div>
          <img
            src={content.logo_url}
            alt="Drywall Local 675"
            className={`h-16 w-auto mb-8 ${content.logo_backdrop === "white" ? "bg-white rounded-sm px-2 py-1" : "drop-shadow-[0_2px_8px_rgba(0,0,0,0.45)]"}`}
            data-testid="footer-logo"
          />
          <p className="text-white/60 text-sm max-w-md leading-relaxed" data-testid="footer-text">
            {content.footer_text}
          </p>
        </div>
        <nav className="flex flex-col gap-3" data-testid="footer-nav">
          <Link to="/" data-testid="footer-home-link" className="text-xs tracking-[0.2em] uppercase font-bold text-white/70 hover:text-brand-sky transition-colors duration-300">Home</Link>
          <Link to="/contact" data-testid="footer-contact-link" className="text-xs tracking-[0.2em] uppercase font-bold text-white/70 hover:text-brand-sky transition-colors duration-300">Contact Us</Link>
          <Link to="/events" data-testid="footer-events-link" className="text-xs tracking-[0.2em] uppercase font-bold text-white/70 hover:text-brand-sky transition-colors duration-300">Events</Link>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <p className="max-w-7xl mx-auto px-6 py-6 text-[11px] tracking-[0.25em] uppercase text-white/35">
          Drywall · Acoustic · Lathing · Insulation
        </p>
      </div>
    </footer>
  );
}
